<template>
  <el-dialog
    custom-class="company-choose-dialog"
    title="切换企业"
    :visible.sync="dialogVisible"
    width="414px"
    @closed="handleClose"
  >
    <div class="compony-content">
      <div v-for="(item, index) in companyList" :key="index" :class="{ 'active-choose': nowCompany === item.id }" @click="changeNowCompany(item)">
        <p><span>{{ item.name || '--' }}</span> <span v-if=" userInfo.accountId === item.id" class="is-now">(当前公司)</span></p>
        <svg-icon icon-class="choose" />
      </div>
    </div>
    <div class="compony-btn">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="loading" @click="changeCompany">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCompanyInfo } from '@/api/user'
import { mapState } from 'vuex'
export default {
  name: 'CompanyChoose',
  inject: ['refreshPage'],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      companyList: [],
      nowCompany: '',
      loading: false
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.getCompanyInfoList()
  },
  mounted() {
    this.nowCompany = this.userInfo.accountId
  },
  methods: {
    // 选择公司
    changeNowCompany(item) {
      this.nowCompany = item.id
    },
    // 切换公司
    async changeCompany() {
      if (this.nowCompany === this.userInfo.accountId) {
        this.$message.error('已在当前企业下！')
        return this.$emit('update:visible', false)
      }
      if (this.loading) return
      this.loading = true
      this.$store.dispatch('user/changeCompany', this.nowCompany).then(() => {
        this.loading = false
        this.$emit('update:visible', false)
        console.log('refreshPage', this.refreshPage)
        // this.refreshPage()
        window.location.reload()
      }).finally(() => {
        this.loading = false
      })
    },
    // 弹窗关闭
    handleClose() {
      // 重置回最初的公司然后关闭弹窗
      this.nowCompany = this.userInfo.accountId
      this.$emit('update:visible', false)
    },
    async getCompanyInfoList() {
      try {
        const res = await getCompanyInfo()
        if (res.code === 200 && res.data) {
          this.companyList = res.data
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .company-choose-dialog {
      .compony-content {
      width: 100%;
      height: 240px;
      background: rgba(44,81,239,0.04);
      border-radius: 3px;
      margin-bottom: 16px;
      overflow-y: auto;
        >div {
          height: 48px;
          cursor: pointer;
          padding: 0px 25px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          transition: all 0.2s;
          svg {
            opacity: 0;
          }
          &.active-choose {
            background-color: #2C51EF;
            color: #FFFFFF;
            svg {
              opacity: 1;
            }
            &:hover {
              background-color: #2C51EF;
            // svg {
            //   opacity: 1;
            // }
          }
          }
          &:hover {
            background-color:rgba(44,81,239,0.1);
            // svg {
            //   opacity: 1;
            // }
          }
          .is-now {
            padding-left: 8px;
          }
        }
      }
      .compony-btn {
        display: flex;
        justify-content: flex-end;
        .el-button--default {
          border: 1px solid #2F4BDD;
          color: #2F4BDD;
        }
      }
    }
</style>
